import TableStatus from '../../../../../components/templates/TableStatus/TableStatus';
import { AdminSortersTable } from './organisms';

const AdminSortersLayout = ({
  tableProps,
  isLoading,
  isError,
  error,
  tableStatusProps,
}) => {
  return (
    <TableStatus
      {...tableStatusProps}
      isLoading={isLoading}
      isError={isError}
      error={error}
      table={<AdminSortersTable tableProps={tableProps} />}
    />
  );
};

export default AdminSortersLayout;
